export const displayDate = (date) => {
  let dt = new Date(date).toString();
  let dt1 = dt.slice(8, 10);
  let month = dt.slice(4, 7);
  let year = dt.slice(11, 15);

  let resultDate = dt1 + " " + month + ", " + year;

  return resultDate;
};

export const amountFormater = (amt) => {
  return `\u20B9${!!amt
      ? amt?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",")
      : "0"
    }`;
};

export const convertDate = (dateFromBack) => {
  // Convert to date Object 
  const dateAndTime = dateFromBack;
  const [date, time] = dateAndTime.split(" ");
  const [dayNumber, month, year] = date.split("-");
  const dateObj = new Date(`${year}-${month}-${dayNumber}`);
  const week = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const day = dateObj.getDay();
  return week[day];
}

export const toTitleCase = (str = "") => {
  if (!str) return "";
  const words = str.split(" ");
  const lowerCaseWords = words.map(word => {
    const lowerCaseStr = word.toLowerCase();
    return lowerCaseStr.charAt(0).toUpperCase() + lowerCaseStr.slice(1);
  })
  return lowerCaseWords.join(" ");

}
// Validations for decimal numbers or numbers etc remaining

export const partnerDetails = () => {
  let part = sessionStorage.getItem("partnerDetails")
  if (part && Object.entries(part).length) {
    return JSON.parse(part)
  } else {
    let obj = {
      partnerLogoPath: "https://prodondcdoc.easypay.co.in/partner_logo/easypay_logo.png",
      partnerName: "Easy Pay",
      partnerFaviconLogoPath: "https://prodondcdoc.easypay.co.in/partner_logo/easypay_favicon.ico"
    }
    sessionStorage.setItem("partnerDetails", JSON.stringify(obj))
    return obj
  }
};

export const getCurrentMonthStart = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
};

export const getToday = () => {
  return new Date();
};

export const generateRandomNumber = () => {
  const number = Math.floor(1000000000 + Math.random() * 9000000000);
  return number.toString();
};

// Storefront product listings show an estimated delivery date; the backend
// doesn't return shipping-timeline data, so this is a plain N-days-from-now
// estimate formatted like "Fri, 28 Aug".
export const getEstimatedDeliveryLabel = (daysFromNow = 5) => {
  const date = new Date();
  date.setDate(date.getDate() + daysFromNow);
  return new Intl.DateTimeFormat("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "short",
  }).format(date);
};
export const normalizeTranslationKey = (str) =>
  str?.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '') || '';

// translate order/fulfillment status labels coming from the backend regardless
// of their exact casing/spacing (e.g. "In-progress", "In Progress", "IN_PROGRESS")
const ORDER_STATUS_TRANSLATION_KEYS = {
  all: "All",
  accepted: "Accepted",
  created: "Created",
  readytoship: "Ready-to-ship",
  riderassigned: "Rider-assigned",
  inprogress: "In-progress",
  completed: "Completed",
  cancelled: "Cancelled",
  rto: "RTO",
  pending: "Pending",
  packed: "Packed",
  agentassigned: "Agent-assigned",
  outforpickup: "Out-for-pickup",
  orderpickedup: "Order-picked-up",
  intransit: "In-transit",
  atdestinationhub: "At-destination-hub",
  outfordelivery: "Out-for-delivery",
  orderdelivered: "Order-delivered",
  pickupfailed: "Pickup-failed",
  deliveryfailed: "Delivery-failed",
  open: "Open",
  processing: "Processing",
  close: "Close",
  closed: "Closed",
  resolved: "Resolved",
};

export const translateOrderStatusLabel = (t, status) => {
  const normalized = status?.toLowerCase().replace(/[^a-z0-9]/g, "");
  const key = ORDER_STATUS_TRANSLATION_KEYS[normalized];
  return key ? t(`orders.status.${key}`) : status;
};

// translate issue status labels (Open/Resolved/Closed) coming from the backend
const ISSUE_STATUS_TRANSLATION_KEYS = {
  open: "open",
  resolved: "resolved",
  closed: "closed",
};

export const translateIssueStatusLabel = (t, status) => {
  const normalized = status?.toLowerCase().replace(/[^a-z0-9]/g, "");
  const key = ISSUE_STATUS_TRANSLATION_KEYS[normalized];
  return key ? t(`issues.${key}`) : status;
};

// translate issue resolution-action labels coming from the backend
// (IGM.Resolved.Action core-category options); unmapped values fall back
// to the raw backend text since new action types can be added server-side
const ISSUE_RESOLUTION_ACTION_TRANSLATION_KEYS = {
  noactionjustresolvedbyprovidingcomment: "noActionResolution",
  refundprovideorderedamountasarefund: "refundAction",
  cancelcanceltheorder: "cancelAction",
};

export const translateIssueResolutionActionLabel = (t, actionName) => {
  const normalized = actionName?.toLowerCase().replace(/[^a-z0-9]/g, "");
  const key = ISSUE_RESOLUTION_ACTION_TRANSLATION_KEYS[normalized];
  return key ? t(`issues.${key}`) : actionName;
};

// translate order cancellation reason labels coming from the backend
// (ONDC cancellation reason list); unmapped values fall back to the raw
// backend text since new reasons can be added server-side
const CANCELLATION_REASON_TRANSLATION_KEYS = {
  oneormoreitemsintheordernotavailable: "itemsNotAvailable",
  storerejectedtheorder: "storeRejectedOrder",
  deliveryaddressnotserviceable: "deliveryAddressNotServiceable",
  pickupaddressnotserviceable: "pickupAddressNotServiceable",
  orderlostintransit: "orderLostInTransit",
  orderconfirmationfailure: "orderConfirmationFailure",
  retailbuyercantdoesntwanttoacceptdelivery: "buyerCannotAcceptDelivery",
  technicalissueinmerchantdevice: "technicalIssueInMerchantDevice",
};

export const translateCancellationReasonLabel = (t, reasonText) => {
  const normalized = reasonText?.toLowerCase().replace(/[^a-z0-9]/g, "");
  const key = CANCELLATION_REASON_TRANSLATION_KEYS[normalized];
  return key ? t(`orders.cancellationReasons.${key}`) : reasonText;
};

// translate the "cancelled by" actor label (Seller/Buyer/LSP) coming from
// the backend regardless of casing
const CANCELLED_BY_TRANSLATION_KEYS = {
  seller: "Seller",
  buyer: "Buyer",
  lsp: "Lsp",
};

export const translateCancelledByLabel = (t, cancelledBy) => {
  const normalized = cancelledBy?.toLowerCase().replace(/[^a-z0-9]/g, "");
  const key = CANCELLED_BY_TRANSLATION_KEYS[normalized];
  return key ? t(`orders.cancelledByValues.${key}`) : cancelledBy;
};

const SETTLEMENT_STATUS_TRANSLATION_KEYS = {
  settled: "Settled",
  unsettled: "Unsettled",
  notsettled: "NotSettled",
  notsettle: "NotSettled",
  refunded: "Refunded",
  pending: "Pending",
  processing: "Processing",
  failed: "Failed",
  onhold: "OnHold",
};

// translate settlement status labels (Settled/Not-Settled/Refunded/etc.)
// coming from the backend regardless of casing/spacing/hyphenation
export const translateSettlementStatusLabel = (t, status) => {
  const normalized = status?.toLowerCase().replace(/[^a-z0-9]/g, "");
  const key = SETTLEMENT_STATUS_TRANSLATION_KEYS[normalized];
  return key
    ? t(`orders.settlementStatusValues.${key}`)
    : translateOrderStatusLabel(t, status);
};

// translate known backend RESP_MSG strings that always come back in English,
// regardless of the app's selected language. Unknown messages fall through
// untranslated (same as before) since we can't guess their meaning.
const API_MESSAGE_TRANSLATION_KEYS = {
  nothingtoupdateforthisorder: "NothingToUpdate",
  cancellationnotallowedoncurrentorderstatus: "CancellationNotAllowed",
  sellerorderpaymentsettlementdetailsnotfound: "SettlementDetailsNotFound",
  noissuesfound: "NoIssuesFound",
  facingtechnicalissuewhileprocessingyourrequesttryagainorcontacttohelpdesk:
    "FacingTechnicalIssue",
  noresultfound: "NoResultFound",
  norecordfound: "NoRecordFound",
  requestprocesssuccessfully: "RequestProcessedSuccessfully",
  requestsuccessfullyprocessed: "RequestProcessedSuccessfully",
  buyerqrnotavailableweareworkingtoaddbuyerqrforyourstore: "BuyerQrNotAvailable",
  notfoundanyproductsubcategory: "NoProductSubcategoryFound",
  logisticpartnersuccessfullymapped: "LogisticPartnerMapped",
  logisticpartnersuccessfullyunmapped: "LogisticPartnerUnmapped",
  variantdetailsareincomplete: "VariantDetailsIncomplete",
  nosellerisassociatedwiththeprovidedmobilenumberpleasecompleteregistrationtoproceed:
    "NoSellerAssociatedWithMobile",
  otpsentsuccessfully: "OtpSentSuccessfully",
  invalidmobilenumber: "InvalidMobileNumber",
  yourinquiryreacheduswewillshortlyconnectyouregardingthis: "InquiryReceived",
  thisvariantisalreadymappedwithanotherproduct: "VariantAlreadyMapped",
  thestoreisnotactivepleaseensureallrequireddetailsaresubmittedandapprovedforfurtherassistancecontactsupport:
    "StoreNotActive",
  otpverificationfailedpleaseprovidecorrectdetails: "OtpVerificationFailed",
  productspecificdeliverychargenotfoundforthisproduct: "DeliveryChargeNotFound",
  productwithsameskuidalreadyaddedpleasechangetheskuidtoaddorupdateproduct:
    "ProductWithSameSkuIdAlreadyAdded",
};

export const translateApiMessage = (t, message) => {
  const normalized = message?.toLowerCase().replace(/[^a-z0-9]/g, "");
  const key = API_MESSAGE_TRANSLATION_KEYS[normalized];
  return key ? t(`orders.messages.${key}`) : message;
};

// translate dynamic per-category "extra field" labels (Material, Brand, Colour
// Name, etc.) coming from the backend, using the shared attributes catalog.
// Falls back to the backend's own fieldName for anything not in the catalog
// (new/unknown attributes just keep showing in English, same as before).
const MISSING_TRANSLATION = "__missing__";

export const translateExtraFieldLabel = (t, fieldKey, fallbackName) => {
  const normalizedKey = normalizeTranslationKey(fieldKey);
  if (normalizedKey) {
    const byKey = t(`attributes.${normalizedKey}`, MISSING_TRANSLATION);
    if (byKey !== MISSING_TRANSLATION) return byKey;
  }
  // fieldKey is often an opaque backend code that doesn't match the catalog
  // (e.g. camelCase, abbreviations); fall back to matching on the visible
  // fieldName text itself, since that's what the catalog is actually keyed by.
  const normalizedName = normalizeTranslationKey(fallbackName);
  if (normalizedName) {
    const byName = t(`attributes.${normalizedName}`, MISSING_TRANSLATION);
    if (byName !== MISSING_TRANSLATION) return byName;
  }
  return fallbackName;
};

// translate dynamic per-category "extra field" dropdown option values (e.g.
// Android/iOS, 4G/5G, Yes/No) coming from the backend, using a shared value
// catalog. Falls back to the backend's own value for anything not in the
// catalog (new/unknown values just keep showing in English, same as before).
export const translateExtraFieldValue = (t, value) => {
  const normalized = value
    ?.toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  if (!normalized) return value;
  return t(`attributeValues.${normalized}`, value);
};

export const handleCopyComnFn = (text, toast, toastId) => {
  if (text) {
    navigator.clipboard.writeText(text)
      .then(() => {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.success("Copied", { autoClose: 1000 });
        }
      })
      .catch(() => {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error("Please try after some time");
        }
      });
  }
};
